import { Typography, Button } from "antd";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AppState } from "store";
import {deleteBatteryModel, setModalName} from "store/actions";

const { Text, Title } = Typography;

export default function DeleteBatteryModelForm() {
    const { selectedBatteryModel } = useSelector<AppState, AppState["batteryModels"]>(
        (state) => state.batteryModels
    );
    const dispatch = useDispatch();

    const onDelete = useCallback(() => {
        console.log("Selected Model: ", selectedBatteryModel)
        dispatch(
            deleteBatteryModel({id:selectedBatteryModel?.id || ""})
        )
        onCancel();
    }, [dispatch, selectedBatteryModel?.id]);

    const onCancel = useCallback(() => {
        dispatch(setModalName(undefined));
    }, [dispatch]);

    return (
        <section className="delete-modal">
            <Title level={5}>Delete Battery Model</Title>
            <Text type="secondary">
                Are you sure you want to delete {" "}
                <strong>
                    “{selectedBatteryModel?.model}”
                </strong>{" "}
                ?
            </Text>
            <div className="action-btn-container">
                <Button className="cancel-btn" onClick={onCancel}>
                    Cancel
                </Button>
                <Button type="primary" danger onClick={onDelete}>
                    Delete
                </Button>
            </div>
        </section>
    );
}
